import { ArtistTourType, LinkableEntityType } from '@api';

export const getTourArtists = (
  record: ArtistTourType
): LinkableEntityType[] => {
  return [record.artist, record.coHeadliner1, record.coHeadliner2].filter(
    (artist) => artist !== null
  );
};
